module.exports = __webpack_public_path__ + "static/media/xixa.49526574.jpeg";